import React from 'react'
import { Link } from 'react-router-dom'
import { Col } from 'reactstrap'

const Pagination = () => {
  return (
    <Col md={12}>
    <nav aria-label="Page navigation" className="blog-pagination">
      <ul className="pagination justify-content-center blog-pagin">
        <li className="page-item">
          <Link className="page-link" aria-label="Previous">
            <i className="fa fa-angle-left" aria-hidden="true"></i>
          </Link>
        </li>
        <li className="page-item active"><Link className="page-link">1</Link></li>
        <li className="page-item"><Link className="page-link">2</Link></li>
        <li className="page-item"><Link className="page-link">3</Link></li>
        <li className="page-item">
          <Link className="page-link" aria-label="Next">
            <i className="fa fa-angle-right" aria-hidden="true"></i>
          </Link>
        </li>
      </ul>
    </nav>
  </Col>
  )
}

export default Pagination